import { HttpErrorResponse } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NbAuthResult, NbAuthService } from "@nebular/auth";
import { NbToastrService } from "@nebular/theme";

@Component({
  selector: "ngx-forgot-pwd",
  templateUrl: "./forgot-pwd.component.html",
  styleUrls: ["./forgot-pwd.component.scss"],
})
export class ForgotPwdComponent implements OnInit {
  myForm: FormGroup;

  constructor(
    private authService: NbAuthService,
    private toastrService: NbToastrService,
    private formBuilder: FormBuilder
  ) {}

  requestPasswordReset() {
    const email = this.myForm.get("email").value;

    this.authService.requestPassword("email", { email: email }).subscribe(
      (confirmed: NbAuthResult) => {
        this.toastrService.success("Password reset email sent!", "Success");
      },
      (error) => {
        if (error instanceof HttpErrorResponse && error.status === 400) {
          this.toastrService.danger(
            "Email address not found or invalid. Please check your email address and try again.",
            "Error"
          );
        } else {
          this.toastrService.danger(
            "Your operation failed, try again later",
            "Error"
          );
        }
      }
    );
  }
  ngOnInit(): void {
    this.myForm = this.formBuilder.group({
      email: ["", [Validators.required, Validators.email]],
    });
  }
}
